import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { SECTORS } from "../lib/sectors";
import { StatusLabel } from "./sectors/SectorParts";

const HomeSectors = () => (
    <section
        data-testid="home-sectors-teaser"
        className="relative border-y border-white/10 bg-ink py-24 lg:py-28"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    BUILDING SECTORS
                </p>
                <span className="h-px flex-1 bg-white/10" />
            </motion.div>

            <div className="mt-10 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
                <motion.h2
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    data-testid="home-sectors-headline"
                    className="max-w-3xl font-display text-3xl font-semibold leading-[1.1] text-white md:text-5xl"
                >
                    Built for homes today. Architected for tomorrow
                    <span className="text-accent">.</span>
                </motion.h2>
                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                >
                    <Link
                        to="/sectors"
                        data-testid="home-sectors-cta"
                        className="group inline-flex items-center gap-2 border border-white/25 px-6 py-3.5 text-[15px] font-medium text-white transition-colors duration-300 hover:border-accent"
                    >
                        Explore Building Sectors
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                </motion.div>
            </div>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4"
            >
                {SECTORS.map((s) => (
                    <motion.div
                        key={s.id}
                        variants={fadeUp}
                        data-testid={`home-sector-${s.id}`}
                        className="bg-ink p-6"
                    >
                        <div className="flex items-center justify-between">
                            <span className="font-mono text-[13px] tracking-[0.22em] text-cad">
                                {s.n}
                            </span>
                            {s.tier === "core" && (
                                <span
                                    data-testid="home-sector-current-focus-dot"
                                    aria-label="Current focus sector"
                                    className="h-1.5 w-1.5 bg-accent"
                                />
                            )}
                        </div>
                        <h3 className="mt-6 font-display text-lg font-semibold leading-snug text-white">
                            {s.title}
                        </h3>
                        <div className="mt-4">
                            <StatusLabel
                                tier={s.tier}
                                id={`home-sector-status-${s.id}`}
                            >
                                {s.status}
                            </StatusLabel>
                        </div>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default HomeSectors;
